/**
 * CRO-WEB-178 Experiment Hook
 *
 * Hook that determines whether to show the email form directly or show a "Continue with Email" button first.
 * Returns configuration for the signup form behavior.
 */

import { useExperimentTracking } from "@/src/experiments/useExperimentTracking";
import { logger } from "@/src/utils/logger";
import { croWeb178Config } from "./config";
import { CroWeb178Variant, useCroWeb178Variant } from "./getCroWeb178Variant";

export interface CroWeb178ExperimentConfig {
  shouldShowEmailButton: boolean; // true = show button first, false = show form directly
  variant: CroWeb178Variant | null;
  isLoading: boolean;
}

/**
 * Hook that determines the signup form behavior for CRO-WEB-178 experiment
 */
export const useCroWeb178Experiment = (): CroWeb178ExperimentConfig => {
  const { variant, isInitialized } = useCroWeb178Variant();

  // Track experiment participation
  useExperimentTracking(croWeb178Config);

  // Determine if we're still loading the variant
  const isLoading = false;

  // DEBUG: Log the variant value (not in production)
  logger.log(
    "🧪 CRO-WEB-178 Experiment variant:",
    variant,
    "isLoading:",
    isLoading
  );

  // Determine behavior based on variant
  const shouldShowEmailButton = variant === "continue-with-email";

  return {
    shouldShowEmailButton,
    variant,
    isLoading,
  };
};
